import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  updateParticipantInfo: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/audiences/participant-info`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const updateParticipantInfo = async (payload) => {
  const res = await resource.updateParticipantInfo(payload)
  return res.body
}

export default {
  initResource,
  updateParticipantInfo,
}
